import { createSelector } from 'reselect';

export const withHoldingListSelector = createSelector(
  (state) => state.invoiceReducer.listReteFuente,
  (state) => state.invoiceReducer.listReteRenta,
  (listReteFuente, listReteRenta) => ({ listReteFuente, listReteRenta })
);
